import React from 'react';

// Shared by the per-machine/per-license CommandLogModal and the standalone
// Command Logs listing, so an expanded row looks the same in both places.

// Metadata is an optional free-form JSON payload. It can arrive as a parsed
// object/array (mysql2 JSON column) or, defensively, as a JSON string.
// Returns a non-empty object/array, or null when there's nothing to show.
export const parseMetadata = (metadata) => {
  if (metadata == null) return null;
  let obj = metadata;
  if (typeof metadata === 'string') {
    const trimmed = metadata.trim();
    if (!trimmed) return null;
    try {
      obj = JSON.parse(trimmed);
    } catch (e) {
      return { value: trimmed };
    }
  }
  if (typeof obj !== 'object' || obj === null) return { value: String(obj) };
  if (Array.isArray(obj)) return obj.length ? obj : null;
  return Object.keys(obj).length ? obj : null;
};

export const hasMetadata = (row) => parseMetadata(row && row.metadata) !== null;

// Compact, responsive key/value grid shown only for rows that carry metadata.
export const MetadataDetail = ({ data }) => {
  const meta = parseMetadata(data && data.metadata);
  if (!meta) return null;

  const entries = Array.isArray(meta)
    ? meta.map((v, i) => [String(i + 1), v])
    : Object.entries(meta);

  return (
    <div
      style={{
        padding: '12px 16px',
        backgroundColor: '#f8f9fa',
        borderLeft: '3px solid #883484',
      }}
    >
      <div
        style={{
          fontSize: '11px',
          fontWeight: 600,
          color: '#6c757d',
          marginBottom: 8,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        Metadata
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '8px',
        }}
      >
        {entries.map(([key, value]) => (
          <div
            key={key}
            style={{
              backgroundColor: '#fff',
              border: '1px solid #e9ecef',
              borderRadius: 6,
              padding: '6px 10px',
              minWidth: 0,
            }}
          >
            <div
              style={{
                fontSize: '11px',
                color: '#883484',
                fontWeight: 600,
                textTransform: 'capitalize',
                marginBottom: 2,
              }}
            >
              {key.replace(/_/g, ' ')}
            </div>
            <div
              style={{
                fontSize: '13px',
                color: '#212529',
                wordBreak: 'break-word',
                fontFamily:
                  typeof value === 'object' && value !== null ? 'monospace' : undefined,
              }}
            >
              {typeof value === 'object' && value !== null
                ? JSON.stringify(value)
                : String(value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
